import(/* webpackMode: "eager" */ "C:\\Users\\info\\Herd\\fleetdirect\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\info\\Herd\\fleetdirect\\src\\app\\why-choose-direct-sale\\components\\FAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\info\\Herd\\fleetdirect\\src\\app\\why-choose-direct-sale\\components\\MarketData.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\info\\Herd\\fleetdirect\\src\\app\\why-choose-direct-sale\\components\\ROICalculator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\info\\Herd\\fleetdirect\\src\\components\\common\\Header.tsx");
;
import(/* webpackMode: "eager" */ "C:\\Users\\info\\Herd\\fleetdirect\\src\\components\\ui\\AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\info\\Herd\\fleetdirect\\src\\components\\ui\\AppImage.tsx");
